"use strict";

exports.__esModule = true;
exports.default = _default;

var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _react = _interopRequireWildcard(require("react"));

var _Scrollbar = _interopRequireDefault(require("material-ui-shell/lib/components/Scrollbar"));

var _reactWindow = require("react-window");

var _VirtualLists = require("material-ui-shell/lib/providers/VirtualLists");

var _Theme = require("material-ui-shell/lib/providers/Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CustomScrollbarsVirtualList = _react.default.forwardRef(function (props, ref) {
  var style = props.style,
      rest = _objectWithoutPropertiesLoose(props, ["style"]);

  var _useAppTheme = (0, _Theme.useTheme)(),
      isRTL = _useAppTheme.isRTL;

  return /*#__PURE__*/_react.default.createElement(_Scrollbar.default, _extends({}, rest, {
    forwardedRef: ref,
    style: _extends(_extends({}, style), {}, {
      overflow: 'hidden',
      direction: isRTL ? 'rtl' : 'ltr'
    }) //james- keep as maybe related to <FixedSizeList> props, will remove soon

  }));
});

function _default(props) {
  var _props$list = props.list,
      list = _props$list === void 0 ? [] : _props$list,
      listProps = props.listProps,
      Row = props.Row,
      name = props.name,
      _props$preserveScroll = props.preserveScroll,
      preserveScroll = _props$preserveScroll === void 0 ? true : _props$preserveScroll;

  var listRef = _react.default.createRef();

  var _useState = (0, _react.useState)(false),
      ref = _useState[0],
      setRef = _useState[1];

  var _useVirtualLists = (0, _VirtualLists.useVirtualLists)(),
      getOffset = _useVirtualLists.getOffset,
      setOffset = _useVirtualLists.setOffset;

  var _useAppTheme2 = (0, _Theme.useTheme)(),
      isRTL = _useAppTheme2.isRTL;

  (0, _react.useEffect)(function () {
    var scrollOffset = getOffset(name);

    if (preserveScroll && ref && scrollOffset) {
      listRef.current.scrollTo(scrollOffset);
    }

    return function () {
      try {
        if (preserveScroll && listRef.current) {
          var offset = listRef.current.state.scrollOffset;
          setOffset(name, offset);
        }
      } catch (error) {
        console.warn('Could not save scrollOffset', error);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
  return /*#__PURE__*/_react.default.createElement(_reactVirtualizedAutoSizer.default, {
    style: {
      height: '100%',
      width: '100%'
    }
  }, function (_ref) {
    var height = _ref.height,
        width = _ref.width;
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      style: {
        padding: 0
        /* , direction: isRTL ? 'rtl':'ltr' */

      }
    }, /*#__PURE__*/_react.default.createElement(_reactWindow.FixedSizeList, _extends({
      direction: isRTL ? 'rtl' : 'ltr' //removes native scrollbar
      ,
      ref: function ref(r) {
        if (r) {
          listRef.current = r;
          setRef(true);
        }
      },
      height: height,
      itemCount: list.length,
      width: width,
      outerElementType: CustomScrollbarsVirtualList
    }, listProps), function (p) {
      return /*#__PURE__*/_react.default.createElement(Row, _extends({}, p, {
        data: list[p.index]
      }));
    }));
  });
}

module.exports = exports.default;